/**
 * Checks if the given value is an object.
 * Returns true if the value is not null and is of type 'object'.
 */
export const isObject = (value: unknown) => value !== null && typeof value === "object"
